module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp12_7042.888d8866.png";